/* eslint-disable @typescript-eslint/naming-convention */

export const CHAT_MESSAGES_LIMIT: number = 300;

export const CUSTOM_NAME_SUFFIX = '_custom_login_';

export const IdentityPrefix = {
  TEACHER: `teacher${CUSTOM_NAME_SUFFIX}`,
  SUPPORT: `support${CUSTOM_NAME_SUFFIX}`,
  OBSERVER: `observer${CUSTOM_NAME_SUFFIX}`,
  GUEST: `guest${CUSTOM_NAME_SUFFIX}`,
};

export enum WrtcProvider {
  TWILIO = 'twilio',
  OPENTOK = 'opentok'
}

export enum AccessType {
  TEACHER = 'TEACHER',
  SUPPORT = 'SUPPORT',
  STUDENT = 'STUDENT',
  OBSERVER = 'OBSERVER',
}

export enum ConnectionStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  PENDING = 'PENDING'
}

export enum ViewportTab {
  ASSIGNMENT,
  WHITEBOARD,
  REPORT,

  BLACKBOARD,
  CHAT
}

export enum Role {
  STAFF = 'STAFF',
  STUDENT = 'STUDENT',
  STAFF_ADMIN = 'STAFF_ADMIN'
}

export enum KeyCode {
  DELETE = 'Delete',
  ESC = 'Escape',
  ARR_DOWN = 'ArrowDown',
  ARR_UP = 'ArrowUp',
  ARR_LEFT = 'ArrowLeft',
  ARR_RIGHT = 'ArrowRight',
  KEY_A = 'KeyA',
  KEY_X = 'KeyX',
  KEY_C = 'KeyC',
  KEY_V = 'KeyV',
  KEY_S = 'KeyS',
  KEY_M = 'KeyM'
}

/* Prevent comparing ShiftLeft, ControlRight, etc. */
export enum Key {
  SHIFT = 'Shift',
  CTRL = 'Control',
}

export enum LogLevel {
  ERROR,
  WARN,
  INFO,
  DEBUG
}

export enum LogResource {
  CORE,
  SOCKET,
  WRTC,
  WHITEBOARD,
  ASSIGNMENT
}

export enum ReminderEmailStatus {
  NOT_TRIGGERED,
  PENDING,
  SUCCESS,
  ERROR
}

export enum JsonLogAction {
  LATE_STUDENT = 'LATE_STUDENT',
  WB_TOOL_ACTIVATE = 'WB_TOOL_ACTIVATE',
  BB_ERASER = 'BB_ERASER',
  ASMT_REFRESH = 'ASMT_REFRESH',
  CONN_TO_TEACHER = 'CONN_TO_TEACHER',
  DISCONN_FROM_TEACHER = 'DISCONN_FROM_TEACHER',
}
